import { httpInstance } from '@/services/httpInstance';

const deleteAmountService = async (amountId) => {
  let res;
  const endpoint = `/back-office/v1/id/${amountId}`;

  await httpInstance.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deleteAmountService;
